import { Button, Dropdown, Menu } from 'antd';
import { EllipsisIcon } from 'app/components/CommonIcons/CommonIcons';

import { CreateTaskWithRoutesPayload } from 'app/containers/Task/slice/types';
import { FC } from 'react';
import AddRouteToTaskDrawer from '../../../containers/Task/pages/TaskListPage/parts/AddRouteToTaskDrawer/AddRouteToTaskDrawer';
import { useRoutesWithoutTaskListCard } from './hooks/useRoutesWithoutTaskListCard';
import RoutesListCard from 'app/components/RouteListCards/RoutesListCard/RoutesListCard';

interface IProps {
  isDropdownWithoutMoveOption?: boolean;
  routesWithImplement?: CreateTaskWithRoutesPayload | null;
}

const RoutesWithoutTaskListCard: FC<IProps> = ({
  isDropdownWithoutMoveOption,
  routesWithImplement,
}) => {
  const {
    onRouteDelete,
    onRoutesCheck,
    setIsAddRouteToTaskDrawerVisible,
    t,
    onToggleAllRoutes,
    isAllRoutesChecked,
    checkedRouteIds,
    isAddRouteToTaskDrawerVisible,
    isRoutesFetching,
    routesWithFields,
  } = useRoutesWithoutTaskListCard({ routesWithImplement });

  return (
    <>
      <RoutesListCard
        groupedRoutes={routesWithFields}
        isLoading={isRoutesFetching}
        checkedRouteIds={checkedRouteIds}
        onRoutesCheck={onRoutesCheck}
        onToggleAllRoutes={onToggleAllRoutes}
        isAllRoutesChecked={isAllRoutesChecked}
        dropdownElement={
          <Dropdown
            trigger={['click']}
            disabled={!checkedRouteIds.length}
            overlay={
              <Menu>
                {!isDropdownWithoutMoveOption && (
                  <Menu.Item
                    onClick={() => setIsAddRouteToTaskDrawerVisible(true)}
                  >
                    {t('Task.MoveToTask', 'Move to task')}
                  </Menu.Item>
                )}

                <Menu.Item onClick={onRouteDelete}>
                  {t('Common.Delete', 'Delete')}
                </Menu.Item>
              </Menu>
            }
          >
            <Button type="primary" shape="circle" size="small">
              <EllipsisIcon $size={12} />
            </Button>
          </Dropdown>
        }
      />

      <AddRouteToTaskDrawer
        isOpen={isAddRouteToTaskDrawerVisible}
        onClose={() => setIsAddRouteToTaskDrawerVisible(false)}
      />
    </>
  );
};

export default RoutesWithoutTaskListCard;
